import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteUserCategoriesService = async (
  categoryId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/user-categories/${categoryId}`);
};

export default deleteUserCategoriesService;
